module.exports = __webpack_public_path__ + "static/img/brand-fourth-3.cb100a44.png";